<template>
  <div class="p-6 md:p-0 md:mt-6">
    <a
      href="/"
      class="block p-4 mb-6 md:hidden">
      <img
        class="w-32 mx-auto"
        src="/img/logo-yuk-belajar-optimized.png"
        alt="Yuk Belajar">
    </a>
    <div>
      <template v-if="primaryExam != null && primaryExam.logo && primaryExam.logo_mobile">
        <img
          class="w-full h-full mb-6 md:hidden"
          :src="'/storage/' + primaryExam.logo_mobile"
          alt="Olimpiade Nasional Tingkat SD/MI">
        <img
          class="w-full h-full hidden md:block mb-6"
          :src="'/storage/' + primaryExam.logo"
          alt="Olimpiade Nasional Tingkat SD/MI">
      </template>
      <div
        class="flex items-center justify-center space-x-5 w-full mb-6 mx-auto md:w-2/3 md:my-12"
        style="color: #001242;">
        <div class="w-20 h-20 md:w-10 md:h-10 flex-shrink-0">
          <svg
            class="fill-current"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 512 512"><rect
              x="48"
              y="80"
              width="416"
              height="384"
              rx="48"
              ry="48"
              style="fill:none;stroke:#000;stroke-linejoin:round;stroke-width:32px" /><path d="M397.82,80H114.18C77.69,80,48,110.15,48,147.2V208H64c0-16,16-32,32-32H416c16,0,32,16,32,32h16V147.2C464,110.15,434.31,80,397.82,80Z" /><circle
                cx="296"
                cy="232"
                r="24" /><circle
                  cx="376"
                  cy="232"
                  r="24" /><circle
                    cx="296"
                    cy="312"
                    r="24" /><circle
                      cx="376"
                      cy="312"
                      r="24" /><circle
                        cx="136"
                        cy="312"
                        r="24" /><circle
                          cx="216"
                          cy="312"
                          r="24" /><circle
                            cx="136"
                            cy="392"
                            r="24" /><circle
                              cx="216"
                              cy="392"
                              r="24" /><circle
                                cx="296"
                                cy="392"
                                r="24" /><line
                                  x1="128"
                                  y1="48"
                                  x2="128"
                                  y2="80"
                                  style="fill:none;stroke:#000;stroke-linecap:round;stroke-linejoin:round;stroke-width:32px" /><line
                                    x1="384"
                                    y1="48"
                                    x2="384"
                                    y2="80"
                                    style="fill:none;stroke:#000;stroke-linecap:round;stroke-linejoin:round;stroke-width:32px" /></svg>
        </div>
        <template v-if="primaryExam != null && primaryExam.started_at && primaryExam.ended_at">
          <div class="ml-3 text-lg md:text-3xl font-bold flex flex-col md:flex-row md:space-x-3 items-center md:space-y-0 space-y-2">
            <span class="whitespace-no-wrap">{{ tanggal(primaryExam.started_at).toUpperCase() }}</span>
            <span class="hidden md:block">-</span>
            <span class="block md:hidden">s/d</span>
            <span class="whitespace-no-wrap">{{ tanggal(primaryExam.ended_at).toUpperCase() }}</span>
          </div>
        </template>
      </div>
      <template v-if="primaryExam != null && primaryExam.description">
        <p class="text-center text-md leading-normal text-gray-900 md:text-xl md:font-semibold">
          {{ primaryExam.description }}
        </p>
      </template>
      <div class="flex-wrap flex md:flex items-center justify-center md:justify-center my-12 lg:my-20">
        <img
          v-if="$store.state.settings != null"
          class="w-11/12 mx-px md:mx-0 md:w-1/3 h-full px-3 md:w-1/3 md:px-6"
          :src="'/storage/' + $store.state.settings.ticket_image"
          alt="Harga tiket (lihat halaman Olimpiade)">
        <div class="md:hidden block w-full h-6" />
        <img
          v-if="$store.state.settings != null"
          class="w-8/12 md:w-1/4 h-full px md:px-8"
          :src="'/storage/' + $store.state.settings.payment_image"
          alt="Bayar Pakai GOPAY, Transfer via ATM, Alfamart">
      </div>
      <div class="text-center w-full pt-12 mb-20">
        <a
          href="/products"
          class="h-24 bg-orange-500 text-white font-bold text-xl py-5 px-8 rounded-lg focus:outline-none active:bg-orange-400"
          @click="$store.commit('setLoading', true)">Beli Tiket</a>
      </div>
      <template v-if="primaryExam != null && primaryExam.sponsors && primaryExam.sponsors.length && primaryExam.sponsors.findIndex((el) => !el.is_pop_up && !el.is_after_module) >= 0">
        <p class="text-xl text-center font-bold text-blue-900 mb-6 lg:text-3xl">
          Disponsori Oleh
        </p>
        <div class="mx-auto mb-16 w-full sm:flex items-center justify-center sm:space-x-10">
          <template v-for="sponsor in primaryExam.sponsors">
            <a
              v-if="!sponsor.is_pop_up && !sponsor.is_after_module"
              :key="sponsor.id"
              class="w-full sm:w-1/2"
              target="_blank"
              rel="nofollow"
              :href="sponsor.url">
              <img
                :src="'/storage/' + sponsor.picture"
                :alt="sponsor.name">
            </a>
          </template>
        </div>
      </template>
      <p class="text-xl text-center font-bold text-blue-900 mb-6 lg:text-3xl">
        Fasilitas Yang Didapat
      </p>
      <div
        v-if="primaryExam != null && primaryExam.facilities"
        class="flex flex-wrap rounded-lg shadow-2xl p-3 mb-12 md:mb-24">
        <div
          v-for="facility in primaryExam.facilities"
          :key="facility.id"
          class="w-full h-full mb-10 md:w-1/3 lg:w-1/3">
          <img
            class="mb-5 w-56 mx-auto h-full"
            :src="'/storage/' + facility.picture"
            :alt="facility.title">
          <p class="text-lg md:text-center font-semibold text-blue-900 mb-3">
            {{ facility.title }}
          </p>
          <p class="text-md md:text-center text-gray-900 leading-normal">
            {{ facility.description }}
          </p>
        </div>
      </div>
      <template v-if="false">
        <p class="text-xl text-center font-bold text-blue-900 mb-6 lg:text-3xl">
          Serentak di {{ $store.state.cities.length }} Kota!
        </p>
        <div class="p-3 md:p-5 mb-12 flex items-center justify-center flex-wrap">
          <div
            v-for="city in $store.state.cities"
            :key="city.id"
            class="flex flex-col items-center justify-center rounded mx-2 my-1 text-gray-800 text-center p-2 rounded-lg shadow-lg">
            <div class="text-xl">
              {{ city.name }}
            </div>
            <template v-if="city.venue != null">
              <div class="w-full h-3" />
              <div v-if="city.map_url != null">
                <a
                  :href="city.map_url"
                  class="text-orange-600"
                  rel="nofollow">{{ city.venue }}</a>
              </div>
              <div v-else>
                {{ city.venue }}
              </div>
            </template>
          </div>
        </div>
      </template>
      <div class="text-center w-full h-24 pt-12">
        <a
          href="/products"
          class="bg-orange-500 text-white font-bold text-xl py-5 px-8 rounded-lg focus:outline-none active:bg-orange-400"
          @click="$store.commit('setLoading', true)">Beli Tiket</a>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  data: function() {
    return {};
  },
  computed: {
    ...mapState(['primaryExam']),
  },
  async mounted() {
    try {
      // await this.$store.dispatch('loadCities');
    } catch (error) {

    }
  },
  methods: {
    tanggal,
  }
}
</script>
